export enum AgeCategory {
  Adult = 'adult',
  Child = 'child'
}

export let ageCategoryNameMapper: Readonly<Record<AgeCategory, string>> = {
  [AgeCategory.Adult]: 'Взрослый',
  [AgeCategory.Child]: 'Ребёнок'
} as const
